import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'

/// Active-customer state for the web app.
///
/// `customerId === null` means consolidated mode — the user sees data
/// from every customer they have access to (the "All" choice in the
/// switcher). A UUID means the user has narrowed to that specific
/// customer; the api-client interceptor will attach it as
/// `X-Customer-Id` on every request.
///
/// Persisted in localStorage so a refresh doesn't drop the user back
/// to "All". When the user signs out, the auth store clears it.
interface CustomerState {
  customerId: string | null
  setCustomer: (id: string | null) => void
  clear: () => void
}

export const useCustomerStore = create<CustomerState>()(
  persist(
    (set) => ({
      customerId: null,
      setCustomer: (id) => set({ customerId: id }),
      clear: () => set({ customerId: null }),
    }),
    {
      name: 'cmms-active-customer',
      storage: createJSONStorage(() => localStorage),
    },
  ),
)
